import React from "react";
import PropTypes from "prop-types";
import Investment from "./investment";
import Util from "../../../common/util";

function InvestmentList(props) {
  const { investments } = props;

  return investments.length > 0 && (
    <section className='row d-flex justify-content-center' id='investments' name='investments'>
      <div className='col-12 col-sm-10'>
        <h2>
          INVESTMENTS
        </h2>
        <div className='row'>
          {Util.arrayInGroupOfArray(investments, 3).map(group => {
            return (
              group.map(investment => {
                return (
                  <Investment
                    {...props}
                    key={investment.id}
                    company={investment}
                  />
                );
              })
            );
          })}
        </div>
      </div>
    </section>
  );
}

InvestmentList.propTypes = {
  investments: PropTypes.arrayOf(PropTypes.object)
};

InvestmentList.defaultProps = {
  investments: []
};

export default InvestmentList;
